import { permissionsSelectors } from 'ducks/permissions'
import { useSelector } from 'react-redux'
import { useFeatureFlag } from 'util/featureFlags'

const useMarketplaceOnNavbarEnabled = () => {
  const enableHardwareOrdering = useFeatureFlag('hardware_ordering', 'on')
  const { allowView } = useSelector((state) => permissionsSelectors.getPermissionByKey(state, 'shop_hardware_access'))
  const isShopEnabled = enableHardwareOrdering && allowView
  const isExpoHookEnabled = useFeatureFlag('expo_hook', 'on')
  const isExpoEnabled = useFeatureFlag('expo', 'on')
  const isMarketPlaceEnabled = isExpoEnabled && isExpoHookEnabled && isShopEnabled
  return {
    isMarketPlaceEnabled,
    isShopEnabled,
    isExpoEnabled,
    isExpoHookEnabled,
  }
}
export default useMarketplaceOnNavbarEnabled
